import { render, staticRenderFns } from "./SignupClient.vue?vue&type=template&id=2da22c6b&"
import script from "./SignupClient.vue?vue&type=script&lang=js&"
export * from "./SignupClient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports